import axios from 'axios';
// import paths from '../paths';
// import { KisaanClient } from './axiosKisaanClient';
import { IExchangeTokenData, IExchangeTokenResponse } from './interface';

export function getKisaanBaseURL() {
  return process.env.APP_KISAN_URI;
}

const getExchangeTokenUrl = (userId: string, realmId: string) => {
  return `${getKisaanBaseURL()}/kisaan/auth/exchangeToken/${userId}`;
};

export const exchangeTokenAsync = async (
  accessToken: string | undefined,
  userId: string,
  realmId: string,
  params: string[] = [],
  setFeedConfig: Function,
  setStreamConfig: Function,
  setModerationFeedConfig?: Function,
  setModerationStreamConfig?: Function
): Promise<IExchangeTokenData | undefined> => {
  try {
    if (accessToken === undefined) return;

    const exchangeTokenData = await axios.get<IExchangeTokenResponse>(
      getExchangeTokenUrl(userId, realmId),
      {
        params: {
          sync: params,
        },
        paramsSerializer: {
          indexes: true, // use brackets with indexes
        },
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
    const { mastodonToken, peerTube, qnaUser } = exchangeTokenData?.data?.data;
    if (mastodonToken) {
      setFeedConfig(mastodonToken);
      setModerationFeedConfig?.(mastodonToken);
    }

    if (peerTube) {
      setStreamConfig(peerTube);
      setModerationStreamConfig?.(peerTube);
    }

    //qna not required as qna token is same as ninjacart accesstoken
    return exchangeTokenData?.data?.data;
  } catch (error) {
    console.error('Exchange token api err : ', error);
  }

  return undefined;
};
